import React, { useState, useEffect, useRef } from 'react';
import './Multiselect.css'; // Import custom CSS for styling

const MultiSelect2 = ({ title, options, selectedValues, onChange, search = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
           }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleDropdown = () => {
        setIsOpen(prevState => !prevState);
    };

    return (
        <div className="multi-select-dropdown" ref={dropdownRef}>
            <div className="d-flex">
                <button type="button" className={`dropdown-toggles w-100`} style={{ fontSize: 14 }} onClick={toggleDropdown}>
                    {title}
                </button>
                {search && (
                    <div className="w-25 m-0 pl-2">
                        <input
                            type="text"
                            className="form-control d-flex h-100"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => {
                                setIsOpen(true);
                                setSearchTerm(e.target.value);
                            }}
                            style={{ fontSize: 14 }}
                        />
                    </div>
                )}
            </div>
            <div className={`dropdown-menu row px-5 row-gap-3 ${isOpen ? 'd-flex' : 'd-none'}`}>
                {options
                    .filter(option =>
                        searchTerm ? option.full_name.toLowerCase().includes(searchTerm.toLowerCase()) : true
                    )
                    .map(option => (
                        <div className="form-check col-6" key={option.user_Id} onClick={() => onChange(option.user_Id)}>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`emp_${option.user_Id}`}
                                checked={selectedValues.includes(option.user_Id)}
                                readOnly
                            />
                            <label className="form-check-label" htmlFor={`emp_${option.user_Id}`} style={{ fontSize: "14px" }}>
                                {option.full_name}
                            </label>
                        </div>
                    ))}
            </div>
        </div>
    );
};


export default MultiSelect2;